const BASE_URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places';

export interface GeocodingSuggestion {
  id: string;
  placeName: string;
  lat: number;
  lng: number;
}

interface MapboxFeature {
  id: string;
  place_name: string;
  center: [number, number]; // GeoJSON: [longitude, latitude]
}

interface MapboxGeocodeResponse {
  features: Array<MapboxFeature>;
}

export const geocodeForward = async (query: string): Promise<Array<GeocodingSuggestion>> => {
  const params = new URLSearchParams({
    access_token: import.meta.env.VITE_MAPBOX_TOKEN,
    types: 'place,region,locality,neighborhood,poi,address',
    limit: '6',
  });

  const response = await fetch(`${BASE_URL}/${encodeURIComponent(query)}.json?${params}`);

  if (!response.ok) throw new Error(`Geocoding error: ${response.status}`);

  const data = (await response.json()) as MapboxGeocodeResponse;

  return data.features.map((f) => ({
    id: f.id,
    placeName: f.place_name,
    lat: f.center[1],
    lng: f.center[0],
  }));
};
